import { Component, OnInit } from "@angular/core";
import { CompaniesService } from "./companies.service";
import { Router } from "@angular/router";

@Component({
  selector: "edit-company",
  template: require('./createcompany.component.html'),
  styles: [require('./createcompany.component.scss')]
})
export class EditCompanyComponent implements OnInit {
  sent: boolean = false;
  activePanels: string[] = ["details"];
  editMode: boolean = true;
  company = { name };

  constructor(private service: CompaniesService, private router: Router) {}

  ngOnInit() {
    if (CompaniesService.currentCompany) {
      this.company = CompaniesService.currentCompany;
    } else {
      this.router.navigate(["/companies"]);
    }
  }

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      if (!this.sent) {
        this.sent = true;
        this.service.editCompany(this.company).subscribe(
          (response) => {
            this.sent = false;
            this.back();
          },
          (error) => {
            this.activePanels = ["details"];
            this.sent = false;
          }
        );
      }
    }, 1);
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/companies/editcompany.component.ts